(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[35],{

/***/ "xkfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/use-places-autocomplete/dist/index.esm.js


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var useLatest = (function (val) {
  var ref = Object(react["useRef"])(val);
  Object(react["useEffect"])(function () {
    ref.current = val;
  });
  return ref;
});

var _debounce = (function (fn, wait) {
  var timer; // eslint-disable-next-line func-names

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }

    timer = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
});

var loadApiErr = "💡 use-places-autocomplete: Google Maps Places API library must be loaded. See: https://github.com/wellyshen/use-places-autocomplete#load-the-library";

var index_esm_usePlacesAutocomplete = function usePlacesAutocomplete(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      requestOptions = _ref.requestOptions,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 200 : _ref$debounce,
      googleMaps = _ref.googleMaps,
      callbackName = _ref.callbackName,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue;

  var _useState = Object(react["useState"])(false),
      ready = _useState[0],
      setReady = _useState[1];

  var _useState2 = Object(react["useState"])(defaultValue),
      value = _useState2[0],
      setVal = _useState2[1];

  var _useState3 = Object(react["useState"])({
    loading: false,
    status: "",
    data: []
  }),
      suggestions = _useState3[0],
      setSuggestions = _useState3[1];

  var asRef = Object(react["useRef"])(null);
  var requestOptionsRef = useLatest(requestOptions);
  var googleMapsRef = useLatest(googleMaps);
  var init = Object(react["useCallback"])(function () {
    var _google$maps;

    var _window = window,
        google = _window.google;
    var gMaps = googleMapsRef.current;
    var placesLib = (gMaps == null ? void 0 : gMaps.places) || (google == null ? void 0 : (_google$maps = google.maps) == null ? void 0 : _google$maps.places);

    if (!placesLib) {
      console.error(loadApiErr);
      return;
    }

    asRef.current = new placesLib.AutocompleteService();
    setReady(true);
  }, []);
  var clearSuggestions = Object(react["useCallback"])(function () {
    setSuggestions({
      loading: false,
      status: "",
      data: []
    });
  }, []);
  var fetchPredictions = Object(react["useCallback"])(_debounce(function (val) {
    if (!val) {
      clearSuggestions();
      return;
    } // To keep the previous suggestions


    setSuggestions(function (prevState) {
      return _extends({}, prevState, {
        loading: true
      });
    }); // @ts-expect-error

    asRef.current.getPlacePredictions(_extends({}, requestOptionsRef.current, {
      input: val
    }), function (data, status) {
      setSuggestions({
        loading: false,
        status: status,
        data: data || []
      });
    });
  }, debounce), [debounce, clearSuggestions]);
  var setValue = Object(react["useCallback"])(function (val, shouldFetchData) {
    if (shouldFetchData === void 0) {
      shouldFetchData = true;
    }

    setVal(val);
    if (shouldFetchData) fetchPredictions(val);
  }, [fetchPredictions]);
  Object(react["useEffect"])(function () {
    var _window2 = window,
        google = _window2.google;

    if (!googleMapsRef.current && !(google != null && google.maps) && callbackName) {
      window[callbackName] = init;
    } else {
      init();
    }

    return function () {
      // @ts-expect-error
      if (window[callbackName]) delete window[callbackName];
    };
  }, [callbackName, init]);
  return {
    ready: ready,
    value: value,
    suggestions: suggestions,
    setValue: setValue,
    clearSuggestions: clearSuggestions
  };
};

/* eslint-disable compat/compat */
var geocodeErr = "💡 use-places-autocomplete: Please provide an address when using getGeocode() with the componentRestrictions.";
var getGeocode = function getGeocode(args) {
  var geocoder = new window.google.maps.Geocoder();
  return new Promise(function (resolve, reject) {
    geocoder.geocode(args, function (results, status) {
      if (status !== "OK") reject(status);

      if (!args.address && args.componentRestrictions) {
        console.error(geocodeErr);
        resolve(results);
      }

      resolve(results);
    });
  });
};
var getLatLng = function getLatLng(result) {
  return new Promise(function (resolve, reject) {
    try {
      var _result$geometry$loca = result.geometry.location,
          lat = _result$geometry$loca.lat,
          lng = _result$geometry$loca.lng;
      resolve({
        lat: lat(),
        lng: lng()
      });
    } catch (error) {
      reject(error);
    }
  });
};
var getZipCode = function getZipCode(result, useShortName) {
  return new Promise(function (resolve, reject) {
    try {
      var zipCode = null;
      result.address_components.forEach(function (_ref) {
        var long_name = _ref.long_name,
            short_name = _ref.short_name,
            types = _ref.types;
        if (types.includes("postal_code")) zipCode = useShortName ? short_name : long_name;
      });
      resolve(zipCode);
    } catch (error) {
      reject(error);
    }
  });
};
var getDetailsErr = "💡use-places-autocomplete: Please provide a place Id when using getDetails() either as a string or as part of an Autocomplete Prediction.";
var getDetails = function getDetails(args) {
  var PlacesService = new window.google.maps.places.PlacesService(document.createElement("div"));

  if (!args.placeId) {
    console.error(getDetailsErr);
    return Promise.reject(getDetailsErr);
  }

  return new Promise(function (resolve, reject) {
    PlacesService.getDetails(args, function (results, status) {
      if (status !== "OK") reject(status);
      resolve(results);
    });
  });
};

/* harmony default export */ var index_esm = (index_esm_usePlacesAutocomplete);


// EXTERNAL MODULE: ./node_modules/google-maps-react/dist/index.js
var dist = __webpack_require__("+567");

// CONCATENATED MODULE: ./src/atomic/molecules/DropdownSuggestions/index.js


var __jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable react/jsx-props-no-spreading */




var DropdownSuggestions_DropdownSuggestions = function DropdownSuggestions(_ref) {
  var open = _ref.open,
      address = _ref.address,
      handleSelect = _ref.handleSelect;

  var _usePlacesAutocomplet = index_esm({
    requestOptions: {
      componentRestrictions: {
        country: "br"
      }
    },
    debounce: 300
  }),
      data = _usePlacesAutocomplet.suggestions.data,
      setValue = _usePlacesAutocomplet.setValue;

  Object(react["useEffect"])(function () {
    setValue(address);
  }, [address, setValue]);

  var renderSuggestions = function renderSuggestions() {
    return data.map(function (suggestion, idx) {
      return __jsx("div", Object(esm_extends["a" /* default */])({}, idx === 0 ? {
        id: "dropdown-suggestions-first-item"
      } : {}, {
        key: idx,
        onClick: function onClick() {
          return handleSelect(suggestion);
        }
      }), suggestion.description);
    });
  };

  if (open) {
    return __jsx("div", {
      className: "autocomplete-wrapper"
    }, renderSuggestions());
  }

  return null;
};

/* harmony default export */ var molecules_DropdownSuggestions = __webpack_exports__["default"] = (Object(dist["GoogleApiWrapper"])({
  apiKey: "AIzaSyD4BJV-u9OzkDAgqkIEKiTatn5_sFs13Dk",
  language: "PT-BR"
})( /*#__PURE__*/Object(react["memo"])(DropdownSuggestions_DropdownSuggestions)));

/***/ })

}]);